import axios from "axios";
// import manifest from "../public/manifest/manifest.json"
import { Loading, ShowAlert } from "../public/js/Utilities"
//•Production
// axios.defaults.baseURL = 'https://localhost:7084/api/'
//•Test

const response = await fetch("/manifest/manifest.json"); // مسیر فایل JSON
const manifest = await response.json();

axios.defaults.baseURL = manifest.api_address

axios.defaults.headers.common['Authorization'] = 'Bearer' + ' ' + localStorage.getItem('token');

axios.interceptors.response.use((response) => response, (error) => {
    // whatever you want to do with the error

    try {
        if (error.message.includes("Network")) {
            Loading(0);
            ShowAlert("danger", "مشکلی در ارتباط وجود دارد", "");
        } else {
            Loading(0);
            ShowAlert("danger", error.message, "");

        }
        if (error.response.status == 401 || error.response.status == 400 || error.message.includes("401")) {
            localStorage.clear();
            location.reload();
        }
    } catch (error) {
        // localStorage.clear();
        // location.reload();
    }

});

// axios.interceptors.response.use((response) => {
//     if (response != undefined) {
//         if (!response.data.isSuccess) {
//             ShowAlert("danger", response.data.message, "");
//         return;
//         }
//         return;
//     }
// });